import { PlayerRecommendations } from "@/features/MyClub/Recommendations/PlayerRecommendations";

/**
 * Player recommendations for the active squad: the squad's pitch on top, the
 * upgrades below, each one previewable on that pitch (DEV-4057). Only club
 * owners get here; without a club, My Club shows its landing instead.
 */
export const MyClubRecommendations = () => <PlayerRecommendations />;
